import * as posedetection from "@tensorflow-models/pose-detection";
import {GameBase} from "./GameBase";
import {AudioInput} from "../common/AudioInput";
import {SoundEffect} from "../common/SoundEffect";
import {Fukidashi} from "../common/Fukidashi";

const PHASE = {
  START: "START",
  CHARGE1: "CHARGE",
  CHARGE2: "CHARGE2",
  SHOOT: "SHOOT",
}
const DEFAULT_Z = 0.3
const SPEED = 700
const SPEED_Z = 1.5
const CHARGE_MAX = 1000

export class ReiGun extends GameBase {
  constructor(settings) {
    super();

    this.power = 0
    this.bulletPos = { x: 0, y: 0, z: DEFAULT_Z }
    this.mousePos = null
    this.vec = { x: 0, y: 5, z: 0 }
    this.poseMode = posedetection.SupportedModels.MoveNet
    // this.poseMode = posedetection.SupportedModels.BlazePose
    this.handMode = true
    this.phase = PHASE.START
    this.debug = ""
    this.voiceThreshold = 5

    this.audioInput = new AudioInput()
    this.charge1Time = 0
    this.coolDownTime = 1000
    this.fukidashi = new Fukidashi()

    this.shootTime = 0
    this.shootCoolDownTime = 5000

    this.soundEffect = new SoundEffect('shoot2')

    window.addEventListener("keydown", (event) => { this.handleKeydown(event) });
  }

  handleKeydown(event){
    if (event.code === 'KeyZ') {
      this.shoot()
    }
    if (event.code === 'KeyX') {
      this.reset()
    }
  }

  drawFukidashi(text) {
    if (!this.mousePos) return

    this.ctx.save();
    this.ctx.scale(-1, 1);
    // console.log(this.mousePos)
    this.fukidashi.draw(this.ctx, this.mousePos, 78, text)
    // this.fukidashi.draw(this.ctx, {x:-300,y:30}, 78, text)
    this.ctx.restore()
  }

  mainLoop({ pose, hands }) {
    // this.cameraRenderer.bgColor = '#000'
    if (!hands) return
    this.right = hands.find(h => h.handedness === "Left")

    if (pose && pose[0]) {
      // console.log(pose)
      const points = pose[0].keypoints
      this.mousePos = { x: -points[0].x+240, y: points[0].y - 120 }
      // this.mousePos = points[0]
    }

    if (this.isCharging()) {
      if (this.power < CHARGE_MAX) {
        this.power++
      }
      if (this.right) {
        const fingerPos = this.right.keypoints[8]
        this.bulletPos = { x: fingerPos.x, y: fingerPos.y, z: DEFAULT_Z }

        let pos3D = this.right.keypoints3D[8]
        this.vec = {x: pos3D.x * SPEED, y: pos3D.y * SPEED, z: -pos3D.z * SPEED_Z }
      }
    }

    switch (this.phase) {
      case PHASE.START:
        if (this.right) {
          this.phase = PHASE.CHARGE1
        }
        break

      case PHASE.CHARGE1:
        if (this.audioInput.volume > this.voiceThreshold) {
          this.charge1Time = new Date().getTime();
          this.phase = PHASE.CHARGE2
        }
        break

      case PHASE.CHARGE2:
        if (this.audioInput.volume > this.voiceThreshold) {
          if (new Date().getTime() - this.charge1Time > this.coolDownTime) {
            this.shoot()
          }
        }
        break

      case PHASE.SHOOT:
        this.bulletPos.x += this.vec.x
        this.bulletPos.y += this.vec.y
        this.bulletPos.z += Math.max(this.vec.z, 0)
        if (this.bulletPos.x < 0 || this.width < this.bulletPos.x
            || this.bulletPos.y < 0 || this.height < this.bulletPos.y
            || this.bulletPos.z < 0.01 || 10.0 < this.bulletPos.z) {
          this.power = 0
        }
        if (new Date().getTime() - this.shootTime > this.shootCoolDownTime) {
          this.reset()
        }
        break
    }
  }

  shoot() {
    this.phase = PHASE.SHOOT
    this.soundEffect.play()
    this.shootTime = new Date().getTime()
  }

  reset() {
    this.phase = PHASE.START
  }

  isCharging() {
    return this.phase === PHASE.CHARGE1 || this.phase === PHASE.CHARGE2
  }
  renderCamera(ctx, { pose, hands }) {
    if (this.phase === PHASE.START) {
      return
    }
    this.ctx = ctx

    switch (this.phase) {
      case PHASE.CHARGE2:
        this.drawFukidashi('霊')
        break
      case PHASE.SHOOT:
        this.drawFukidashi('丸!')
        break
    }

    if (this.phase === PHASE.SHOOT || (this.right && this.isCharging()) ) {
      this.drawCircle(this.bulletPos, this.bulletPos.z * this.power)
    }
  }

  drawLine(p1, p2) {
    this.ctx.beginPath();
    this.ctx.moveTo(p1.x, p1.y);
    this.ctx.lineTo(p2.x, p2.y);
    this.ctx.stroke();
  }

  drawCircle(pos, size) {
    let tmp = this.ctx.globalCompositeOperation
    this.ctx.globalCompositeOperation = "lighter";
    const rand = 20
    for (let i = 0; i < 8; i++) {
      size *= 0.9
      let r1 = Math.random() * rand - rand*0.5;
      let r2 = Math.random() * rand - rand*0.5;
      this.ctx.fillStyle = '#1111ff';
      this.ctx.strokeStyle = this.ctx.fillStyle;
      this.ctx.beginPath();
      this.ctx.arc(pos.x + r1, pos.y + r2, size, 0, Math.PI * 2, true);
      this.ctx.stroke();
      this.ctx.fill();
    }

    this.ctx.globalCompositeOperation = tmp
  }
}



// WEBPACK FOOTER //
// ./src/components/game/ReiGun.js